// extracted by mini-css-extract-plugin
export default {"form":"SdkApplicationModal_form__11i6w","addOriginButton":"SdkApplicationModal_addOriginButton__1J7Se"};